import { APIError } from '../../../../../../../utils'

export const getAccountNumberValidationMessage = (error: unknown): string | undefined => {
  const apiError = error as APIError | undefined

  if (apiError?.statusCode !== 422) {
    return undefined
  }

  return apiError.body?.validationErrors?.record?.attributes?.accountNumber || apiError.body?.errorMessage
}
